import { Course } from './course.model';
import { differenceInDays, isBefore } from 'date-fns';
import { getScheduleInterval } from '../_lib/schedule';

export function canRegisterForCourse(course: Course, maxDays = 0) {
  return (
    !course.full &&
    (course.registrationsOpenedAt === null ||
      isBefore(course.registrationsOpenedAt, new Date())) &&
    differenceInDays(
      getScheduleInterval(course.camp.schedule).start,
      new Date(),
    ) >= maxDays
  );
}

export function isCourse(resource: unknown): resource is Course {
  return (
    resource instanceof Course ||
    (typeof resource === 'object' &&
      resource !== null &&
      (resource as any).registrationsOpenedAt !== undefined &&
      (resource as any).type === undefined)
  );
}
